<template>
  <div>
    
    <!-- Division Role Sidebar -->
    <v-navigation-drawer
      v-if="userRole === 'division'"
      v-model="sideNav"
      app
      :permanent="!$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      fixed
      width="240px"
      class="fixedSidebar"
    >
      <div class="sidebar-header">
        <v-img contain width="38px" height="38px" src="../assets/sarpamp.png" class="sidebar-logo-img mr-2"></v-img>
        <span class="sidebar-title">SARPA <span class="accent-text">MP</span></span>
      </div>

      <div class="sidebar-scroll-container" @scroll="handleSidebarScroll">
        <v-list dense nav class="px-2 pt-4">
          <template v-for="item in filteredItems">
            <!-- IF THE ITEM HAS CHILDREN (DROPDOWN GROUP) -->
            <v-list-group
              v-if="item.children"
              :key="'group-' + item.title"
              color="#de520c"
              class="nav-group mb-2"
            >
              <!-- Activator template for the parent button -->
              <template v-slot:activator>
                <v-list-item-icon class="mr-3 my-0 align-self-center">
                  <v-icon class="nav-icon">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <!-- Child items revealed when clicking parent -->
              <v-list-item
                v-for="subItem in item.children"
                :key="subItem.title"
                :to="subItem.path"
                link
                class="mb-1"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="18">{{ subItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 13.5px; font-family: poppinsmedium">
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <!-- IF THE ITEM IS A SINGLE LINK -->
            <v-list-item
              v-else
              :key="'item-' + item.title"
              :to="item.path"
              link
              class="nav-item mb-2"
              active-class="active-nav-item"
            >
              <v-list-item-icon class="mr-3">
                <v-icon class="nav-icon">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
  
      </div>
      <div class="sidebar-footer-image"></div>
    </v-navigation-drawer>

    <!-- Circle Role Sidebar -->
    <v-navigation-drawer
      v-if="userRole === 'circle'"
      v-model="sideNav"
      app
      :permanent="!$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      fixed
      width="240px"
      class="fixedSidebar"
    >
      <div class="sidebar-header">
        <v-img contain width="35px" height="35px" src="../assets/sarpamp.png" class="sidebar-logo-img mr-2"></v-img>
        <span class="sidebar-title">SARPA <span class="accent-text">MP</span></span>
      </div>

      <div class="sidebar-scroll-container" @scroll="handleSidebarScroll">
        <v-list dense nav class="px-2 pt-4">
          <template v-for="item in filteredItems1">
            <!-- IF THE ITEM HAS CHILDREN (DROPDOWN GROUP) -->
            <v-list-group
              v-if="item.children"
              :key="'group-' + item.title"
              color="#de520c"
              class="nav-group mb-2"
            >
              <!-- Activator template for the parent button -->
              <template v-slot:activator>
                <v-list-item-icon class="mr-3 my-0 align-self-center">
                  <v-icon class="nav-icon">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <!-- Child items revealed when clicking parent -->
              <v-list-item
                v-for="subItem in item.children"
                :key="subItem.title"
                :to="subItem.path"
                link
                class="mb-1"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="18">{{ subItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 13.5px; font-family: poppinsmedium">
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <!-- IF THE ITEM IS A SINGLE LINK -->
            <v-list-item
              v-else
              :key="'item-' + item.title"
              :to="item.path"
              link
              class="nav-item mb-2"
              active-class="active-nav-item"
            >
              <v-list-item-icon class="mr-3">
                <v-icon class="nav-icon">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <div class="sidebar-footer-image"></div>
      </v-navigation-drawer>

    <!-- Range Role Sidebar -->
    <v-navigation-drawer
      v-if="userRole === 'range'"
      v-model="sideNav"
      app
      :permanent="!$vuetify.breakpoint.smAndDown"
      :temporary="$vuetify.breakpoint.smAndDown"
      fixed
      width="240px"
      class="fixedSidebar"
    >
      <div class="sidebar-header">
        <v-img contain width="38px" height="38px" src="../assets/sarpamp.png" class="sidebar-logo-img mr-2"></v-img>
        <span class="sidebar-title">SARPA <span class="accent-text">MP</span></span>
      </div>

      <div class="sidebar-scroll-container" @scroll="handleSidebarScroll">
        <v-list dense nav class="px-2 pt-4">
          <template v-for="item in filteredItems2">
            <!-- IF THE ITEM HAS CHILDREN (DROPDOWN GROUP) -->
            <v-list-group
              v-if="item.children"
              :key="'group-' + item.title"
              color="#de520c"
              class="nav-group mb-2"
            >
              <!-- Activator template for the parent button -->
              <template v-slot:activator>
                <v-list-item-icon class="mr-3 my-0 align-self-center">
                  <v-icon class="nav-icon">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-0">
                  <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <!-- Child items revealed when clicking parent -->
              <v-list-item
                v-for="subItem in item.children"
                :key="subItem.title"
                :to="subItem.path"
                link
                class="mb-1"
              >
                <v-list-item-icon class="mr-3">
                  <v-icon size="18">{{ subItem.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 13.5px; font-family: poppinsmedium">
                    {{ subItem.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <!-- IF THE ITEM IS A SINGLE LINK -->
            <v-list-item
              v-else
              :key="'item-' + item.title"
              :to="item.path"
              link
              class="nav-item mb-2"
              active-class="active-nav-item"
            >
              <v-list-item-icon class="mr-3">
                <v-icon class="nav-icon">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="font-size: 14px; font-family: poppinsmedium" class="nav-title">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </div>
      <div class="sidebar-footer-image"></div>
      </v-navigation-drawer>

    <!-- Consolidated Main Content Layout wrapper -->
    <v-layout wrap fill-height v-if="userRole === 'division' || userRole === 'circle' || userRole === 'range'">
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="
                $route.name == 'officeDashboard' || $route.name == 'sarpadashboard' || $route.name == 'dashboard'
                  ? 'background-color: #F5F6FA'
                  : 'background-color: #fff6f2'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="
                    $route.name == 'officeDashboard' || $route.name == 'sarpadashboard' || $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </div>
</template>
<script>
import AppHeader from "@/components/Common/appHeadersarpa";

export default {
  components: {
    AppHeader,
  },
  data() {
    return {
      items: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        {
          title: "Rescuers",
          icon: "mdi-account-group",
          children: [
            {
              title: "New Rescuers",
              icon: "mdi-account-plus",
              path: "/officers/newrescuerslist",
            },
            {
              title: "Rescuer List",
              icon: "mdi-account-multiple-plus ",
              path: "/officers/allrescuerlistOfficers",
            },
            {
              title: "Banned Rescuers",
              icon: "mdi-account-multiple-plus ",
              path: "/officers/bannedList",
            },
          ]
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/officers/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-document-multiple-outline",
          path: "/officers/officesnakereport",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/officers/deleteoperations",
        },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/officers/controlRoomList",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/officers/alldistrictlist",
        },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/officers/snakeBiteOfficers",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/officers/fraudcases",
        // },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },

      ],



      items1: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        {
          title: "Rescuers",
          icon: "mdi-account-group",
          children: [
            {
              title: "New Rescuers",
              icon: "mdi-account-plus",
              path: "/officers/newrescuerslist",
            },
            {
              title: "Rescuer List",
              icon: "mdi-account-multiple-plus ",
              path: "/officers/allrescuerlistOfficers",
            },
            {
              title: "Banned Rescuers",
              icon: "mdi-account-multiple-plus ",
              path: "/officers/bannedList",
            },
            {
              title: "Training List",
              icon: "mdi-file-account",
              path: "/officers/officetraininglist",
            },
          ]
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/officers/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-document-multiple-outline",
          path: "/officers/officesnakereport",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/officers/deleteoperations",
        },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/officers/controlRoomList",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/officers/alldistrictlist",
        },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/officers/snakeBiteOfficers",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/officers/fraudcases",
        // },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },

      ],

      items2: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        {
          title: "Rescuers",
          icon: "mdi-account-group",
          children: [
            {
              title: "New Rescuers",
              icon: "mdi-account-plus",
              path: "/officers/newrescuerslist",
            },
            {
              title: "Rescuer List",
              icon: "mdi-account-multiple-plus ",
              path: "/officers/allrescuerlistOfficers",
            },
            {
              title: "Banned Rescuers",
              icon: "mdi-account-multiple-plus ",
              path: "/officers/bannedList",
            },
          ]
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/officers/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-document-multiple-outline",
          path: "/officers/officesnakereport",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/officers/deleteoperations",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/officers/alldistrictlist",
        },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/officers/controlRoomList",
        },
        // {
        //   title: "Training List",
        //   icon: "mdi-file-account",
        //   path: "/officers/traininglist",
        // },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/officers/snakeBiteOfficers",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/officers/fraudcases",
        // },
        {
          title: "Excel",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },
        

      ],
      right: null,
      showExcel: false,
    };
  },
  mounted() {
  },
  beforeDestroy() {
  },
  computed: {
    userRole() {
      return this.$store.state.userRole;
    },
    sideNav: {
      get() {
        return this.$store.state.sideNavOpen;
      },
      set(val) {
        this.$store.commit('setSideNav', val);
      }
    },
    filteredItems() {
      if (this.showExcel) return this.items;
      return this.items.filter((item) => item.title !== "Excel");
    },
    filteredItems1() {
      if (this.showExcel) return this.items1;
      return this.items1.filter((item) => item.title !== "Excel");
    },
    filteredItems2() {
      if (this.showExcel) return this.items2;
      return this.items2.filter((item) => item.title !== "Excel");
    }
  },
  methods: {
    handleSidebarScroll(event) {
      if (event.target.scrollTop > 0) {
        this.showExcel = true;
      } else {
        this.showExcel = false;
      }
    }
  }
};
</script>

<style scoped>
.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 240px) !important;
    width: calc(100% - 240px) !important;
    margin-left: 240px !important;
  }
}

/* Sidebar background */
.fixedSidebar {
  background-color: #feebdb !important; /* synced with mountain image background */
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.04) !important;
  border-right: 1px solid #f0f0f0 !important;
  z-index: 1000 !important;
}

/* Use flex layout to cleanly separate scrollable list from pinned footer */
::v-deep .v-navigation-drawer__content {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important;
  overflow: hidden !important; 
}

.sidebar-scroll-container {
  height: calc(100vh - 68px); /* Full remaining height */
  max-height: calc(100vh - 68px);
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  z-index: 1;
}

.sidebar-footer-image {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 240px; /* Restore full uncropped height */
  background-image: url("../assets/sidebar_footer.jpg");
  background-position: center bottom;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 0;
  pointer-events: none; /* Doesn't block clicks */
}



/* Custom scrollbar for the nav list container */
.sidebar-scroll-container::-webkit-scrollbar {
  width: 8px !important;
}
.sidebar-scroll-container::-webkit-scrollbar-track {
  margin-bottom: 240px; /* Shorten scrollbar track so it doesn't overlap footer */
}
.sidebar-scroll-container::-webkit-scrollbar-thumb {
  background: #de520c !important;
  border-radius: 4px;
}

/* Make list not individually scrollable, let container handle it */
.fixedSidebar ::v-deep .v-list {
  background: transparent !important;
  flex: 0 0 auto !important;
  padding-bottom: 100px !important;
  padding-top: 8px !important;
}

.sidebar-header {
  background: #feebdb !important; /* Sync background color to the rest of the sidebar */
  height: 68px !important;
  min-height: 68px !important;
  max-height: 68px !important;
  border-bottom: 1px solid #f0f0f0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 22px !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
}

.sidebar-logo-img {
  max-height: 38px !important;
  max-width: 38px !important;
  flex-shrink: 0;
}

.sidebar-title {
  font-family: "poppinsmedium", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  letter-spacing: 0.5px;
}

.sidebar-title .accent-text {
  color: #ff7a00;
}

/* Compact Menu Items Reset */
.nav-item {
  position: relative;
  border-radius: 6px !important;
  margin: 1px 10px !important; /* Tighter gap */
  padding: 0 12px !important;
  min-height: 32px !important; /* Reduced row height */
  transition: all 0.2s ease !important;
  display: flex;
  align-items: center;

}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(4px);
}

.nav-icon {
  color: #de520c !important; 
  font-size: 18px !important; /* Reduced icon size */
}

.nav-title {
  color: #333333 !important;
  font-weight: 500 !important;
  font-size: 12.5px !important; /* Reduced font size */
}

.nav-item:hover .nav-icon {
  color: #de520c !important;
}

.nav-item:hover .nav-title {
  color: #000000 !important;
  font-weight: 600 !important;
}

/* Active State Pill */
.active-nav-item {
  background: #de520c !important;
  box-shadow: 0 4px 10px rgba(222, 82, 12, 0.3) !important;
}

.active-nav-item .nav-icon {
  color: #ffffff !important;
}

.active-nav-item .nav-title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Dropdown Parent */
.nav-group ::v-deep .v-list-group__header {
  border-radius: 6px !important;
  margin: 1px 10px !important;
  padding: 0 12px !important;
  min-height: 32px !important;
  transition: all 0.2s ease !important;

}

.nav-group ::v-deep .v-list-group__header:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(4px);
}

.nav-group ::v-deep .v-list-group__header .v-list-item__icon .v-icon,
.nav-group ::v-deep .v-list-group__header .nav-icon {
  color: #de520c !important;
  font-size: 18px !important;
}

.nav-group ::v-deep .v-list-group__header .nav-title,
.nav-group ::v-deep .v-list-group__header .v-list-item__title {
  color: #333333 !important;
  font-weight: 500 !important;
  font-size: 12.5px !important;
}

.nav-group ::v-deep .v-list-group__header:hover .nav-icon,
.nav-group ::v-deep .v-list-group__header:hover .nav-title {
  color: #de520c !important;
}

/* Dropdown Active/Expanded */
.nav-group ::v-deep .v-list-group__header.v-list-item--active {
  background: #de520c !important;
  box-shadow: 0 4px 10px rgba(222, 82, 12, 0.3) !important;
}

.nav-group ::v-deep .v-list-group__header.v-list-item--active .nav-icon,
.nav-group ::v-deep .v-list-group__header.v-list-item--active .nav-title,
.nav-group ::v-deep .v-list-group__header.v-list-item--active .v-list-item__title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* Dropdown Children */
.nav-group ::v-deep .v-list-group__items .v-list-item {
  border-radius: 6px !important;
  margin: 1px 10px 1px 24px !important;
  padding: 0 12px !important;
  min-height: 30px !important; /* Slightly smaller for children */
  transition: all 0.2s ease !important;

}

.nav-group ::v-deep .v-list-group__items .v-list-item .v-icon {
  color: #de520c !important;
  font-size: 16px !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item .v-list-item__title {
  color: #333333 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(4px);
}

.nav-group ::v-deep .v-list-group__items .v-list-item:hover .v-icon,
.nav-group ::v-deep .v-list-group__items .v-list-item:hover .v-list-item__title {
  color: #de520c !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item.v-list-item--active {
  background: #de520c !important;
  box-shadow: 0 2px 6px rgba(222, 82, 12, 0.3) !important;
}

.nav-group ::v-deep .v-list-group__items .v-list-item.v-list-item--active .v-icon,
.nav-group ::v-deep .v-list-group__items .v-list-item.v-list-item--active .v-list-item__title {
  color: #ffffff !important;
  font-weight: 600 !important;
}

</style>





